import React, { useState, useEffect, useRef } from "react";
import Header from './Header';
import Discoversect from './Discoversect/Discoversect';
import Villas from './Villas/Villas';
import Programs from './AllPrograms/programs';
import Exquisite from './Exquisite/Exquisite';
import Footer from './Footer/Footer';
import Foundersmessage from './FoundersMessage/message';
import Model from './threedmodel/model';
import WhatsAppWidget from './whatsapp';
import "lazysizes"; // Install via npm
import "lazysizes/plugins/attrchange/ls.attrchange";
import './Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faDownload } from '@fortawesome/free-solid-svg-icons';
import brochure from '../../assets/hero/brochure.pdf';
import posterImage from '../../../src/assets/hero/landscapethumbnail.jpg';
import mobileposterimage from '../../../src/assets/hero/mobileposter.jpg';
import Allexperiences from "./Allexperiences/Allexperiences";
import WeatherDashboard from "./WeatherDashboard";

function Hero() {
  const video1 = 'https://marvelous-kitten-24ad40.netlify.app/video1.mp4';
  const video2 = 'https://marvelous-kitten-24ad40.netlify.app/video2.mp4';
  const video3 = 'https://marvelous-kitten-24ad40.netlify.app/video3.mp4';
  const video4 = 'https://marvelous-kitten-24ad40.netlify.app/video4.mp4';
  const video5 = 'https://marvelous-kitten-24ad40.netlify.app/video5.mp4';
  const mobileVideo = 'https://marvelous-kitten-24ad40.netlify.app/mobileVideo.mp4';

  const videos = [video1, video2, video3, video4, video5];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [currentProgress, setCurrentProgress] = useState(0);
  const videoRefs = useRef(videos.map(() => React.createRef()));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 550);
  const [loading, setLoading] = useState(true);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 550);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const video = videoRefs.current[currentVideoIndex]?.current;

    if (!isMobileView && video) {
      video.currentTime = 0; // Reset to the beginning
      video.play(); // Start playback

         // Update progress as the video plays
         intervalRef.current = setInterval(() => {
          if (video && video.currentTime && video.duration) {
            const progress = (video.currentTime / video.duration) * 100;
            setCurrentProgress(progress);
          }
        }, 100);

        return () => {
          clearInterval(intervalRef.current);
          setCurrentProgress(0);
        };
      }
    }, [currentVideoIndex]);

  const handleVideoLoaded = () => {
    setLoading(false);
  };

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.download = "Belantara-brochure.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

 const handleVideoEnd = () => {
    const video = videoRefs.current[currentVideoIndex]?.current;
    if (video && Math.abs(video.currentTime - video.duration) < 0.5) {
      // Proceed to the next video only if the current video has ended completely
      const nextIndex = (currentVideoIndex + 1) % videos.length;
      setCurrentVideoIndex(nextIndex);
    }
  };

  const handleDotClick = (index) => {
    if (index !== currentVideoIndex) {
      setCurrentVideoIndex(index);
      setCurrentProgress(0);
      const video = videoRefs.current[index]?.current;
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    }
  };

  return (
    <>
      <Header />
      <section className="hero d-flex align-items-center justify-content-center flex-column">
        {loading && !isContentLoaded && (
          <div className="loader" style={{ position: "absolute", zIndex: 2000 }}>
            <div className="spinner"></div>
          </div>
        )}

        {!isMobileView ? (
          videos.map((video, index) => (
            <video
              key={index}
              ref={videoRefs.current[index]}
              src={video}
              poster={posterImage}
              preload="metadata"
              muted
              playsInline
              className={`hero-video ${index === currentVideoIndex ? "active" : "inactive"}`}
              onEnded={handleVideoEnd}
              onLoadedData={handleVideoLoaded}
              style={{
                display: index === currentVideoIndex ? "block" : "none",
              }}
            />
          ))
        ) : (
          <video
            autoPlay
            loop = {true}
            muted
            playsInline
            className="hero-video lazyload"
            data-src={mobileVideo}
            data-poster={mobileposterimage}
            preload="auto"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            onLoadedData={handleVideoLoaded}
          >
            <source src={mobileVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}

        <div className="hero-text">
          <h1>Enrich Yourself ...</h1>
        </div>

        <div className="btnbox">
          <div
            className="heroPlayBtndiv d-flex gap-2 align-items-center justify-content-center"
            onClick={handleModalToggle}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faCirclePlay} size="2x" style={{ color: "#e6be80" }} />
            <h6 className="text-white mb-0">Watch Full Video</h6>
          </div>
          <div
            className="herodownloadBtndiv d-flex gap-2 align-items-center justify-content-center"
            onClick={handleDownload}
          >
            <FontAwesomeIcon icon={faDownload} size="2x" style={{ color: "#e6be80" }} />
            <h6 className="text-white mb-0">Download Brochure</h6>
          </div>
        </div>

        {isModalOpen && (
          <div
            className="video-modal"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                position: "relative",
                width: "80%",
                maxWidth: "1000px",
                height: "60vh",
                backgroundColor: "#000",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/nV15MsZ_o4Q?rel=0"
                title="Belantara Intro Video 2 mins"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>

              <button
                onClick={handleModalToggle}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "transparent",
                  border: "none",
                  color: "#fff",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ✖
              </button>
            </div>
          </div>
        )}

        <div
          className="progress-container"
          style={{
            position: "absolute",
            bottom: "8%",
            width: "90%",
            height: "20px",
            background: "transparent",
            borderRadius: "5px",
            overflow: "hidden",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: "100",
          }}
        >
          {videos.map((_, index) => (
            <div
              key={index}
              className="progress-segment"
              style={{
                width: `${100 / videos.length}%`,
                display: "inline-block",
                height: "2px",
                background: "#888",
                position: "relative",
              }}
            >
              {index === currentVideoIndex && (
                <div
                  className="progress-bar"
                  style={{
                    width: `${currentProgress}%`,
                    height: "100%",
                    background: "#e6be80",
                    transition: "width 0.1s linear",
                  }}
                />
              )}

              <button
                onClick={() => handleDotClick(index)}
                style={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: "0",
                  width: "15px",
                  height: "15px",
                  backgroundColor: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  cursor: "pointer",
                  zIndex: "100",
                }}
              />
            </div>
          ))}
        </div>
        <WhatsAppWidget />
      </section>

      <Foundersmessage />
      <Discoversect />
      <Allexperiences />
      <Villas />
      <Programs />
      <Exquisite />
      <Model />
      {/* <WeatherDashboard/> */}
      <Footer />
    </>
  );
}

export default Hero;
